import $ from "@modules/jquery";

$(function () {
  const $container = $(".single:not(.hide-ads):not(.hide-autonative) .article-inner");
  if (!$container.length) {
    return;
  }

  function countWords(text = "") {
    if (!text) return 0;

    const words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    return words.length;
  }

  // --- Rule 1: Always insert after the first content paragraph ---
  let firstAdInserted = false;
  $container.children().each(function () {
    const $element = $(this);
    if (
      $element.is("p") &&
      !$element.hasClass("article-author") &&
      !$element.hasClass("article-date")
    ) {
      $element.after('<div id="adf-autonative"></div>');
      firstAdInserted = true;
      return false; // Stop loop.
    }
  });

  // --- Rule 2: Insert before a heading if the preceding paragraph > 60 words ---
  let sequentialAdCounter = 1;
  const maxSequentialAds = 10;
  const headingSelector = "h2, h3, h4, h5, h6";
  $container.children().each(function () {
    const $element = $(this);
    if ($element.is(headingSelector)) {
      const $previousElement = $element.prev();
      if ($previousElement.length) {
        if (
          $previousElement.is("p") &&
          !$previousElement.hasClass("article-author") &&
          !$previousElement.hasClass("article-date") &&
          $previousElement.attr("id") !== "adf-autonative" &&
          countWords($previousElement.text()) >= 60 &&
          sequentialAdCounter <= maxSequentialAds
        ) {
          const adHtml = `<div id="adf-autonative-${sequentialAdCounter + 1}"></div>`;
          $element.before(adHtml);
          sequentialAdCounter++;

          if (sequentialAdCounter > maxSequentialAds) {
            return false; // Stop loop.
          }
        }
      }
    }
  });
});
